import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadar = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.07 4.92883C17.5129 3.37004 15.4845 2.36914 13.3001 2.08162C11.1157 1.7941 8.89743 2.23606 6.98999 3.33883",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 6H4.0075",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.29035 9.62156C1.91544 11.1486 1.90593 12.7426 2.26258 14.274C2.61923 15.8054 3.33198 17.2312 4.34298 18.4355C5.35399 19.6398 6.63473 20.5887 8.08125 21.2052C9.52776 21.8217 11.0993 22.0884 12.6682 21.9836C14.2371 21.8789 15.7592 21.4056 17.1109 20.6023C18.4626 19.7989 19.6058 18.6882 20.4478 17.3601C21.2897 16.0321 21.8065 14.5243 21.9564 12.959C22.1063 11.3938 21.8849 9.81522 21.3103 8.35156",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2403 7.76187C15.6648 7.18304 14.9773 6.72771 14.2197 6.42374C13.4622 6.11978 12.6506 5.97358 11.8346 5.99408C11.0187 6.01458 10.2155 6.20136 9.47415 6.54298C8.73285 6.8846 8.06904 7.37388 7.52335 7.98089C6.97765 8.5879 6.56155 9.29986 6.3005 10.0732C6.03944 10.8466 5.93893 11.6651 6.0051 12.4786C6.07128 13.2922 6.30275 14.0837 6.68536 14.8047C7.06797 15.5257 7.59366 16.161 8.23028 16.6719",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 18H12.0075",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9895 11.6602C18.0439 12.6115 17.8709 13.5622 17.4849 14.4334C17.0988 15.3046 16.5108 16.0714 15.7695 16.6702",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4099 10.5897L19.0699 4.92969",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRadar;
